module.exports = __webpack_public_path__ + "media/images/icons/rooms/bed-2p-couch-120a9edcc7a241a381c200ed3e9462eb.svg";